import { ITopic } from '@common/types';
import { Button } from '@components/ui/button';
import { useTranslation } from 'react-i18next';

interface ISelectTopicProps {
  topics: ITopic[];
  selectTopic: (topicId: string) => void;
}

function SelectTopic(props: ISelectTopicProps) {
  const { t } = useTranslation();

  return (
    <div className="mt-6 text-sm">
      <p className="mb-3">{t('chat.topic_select.not_found')}</p>
      {props.topics.map((topic) => (
        <Button
          key={topic.id}
          className="uppercase bg-xircle-secondary mr-2 mb-3 hover:shadow-md"
          onClick={() => props.selectTopic(topic.id)}
        >
          {topic.displayName || topic.name}
        </Button>
      ))}
    </div>
  );
}

export default SelectTopic;
